import { useSelector } from "react-redux"
import { meSelector } from "./redux/globalSlice"
import { UserRole } from "./api/models"
import { OFFERS_PAGE_ENABLED } from "./featureFlags"

// Whether Your Offers (sidebar item, /offers route, Dashboard teaser) shows
// for the signed-in user: withdrawn for customers while
// OFFERS_PAGE_ENABLED is false (featureFlags.ts), always on for system-wide
// admins (the platform role, not vendor memberships) so the page keeps
// being exercised meanwhile.
export function useOffersPageEnabled(): boolean {
  const me = useSelector(meSelector)?.data
  return OFFERS_PAGE_ENABLED || me?.role === UserRole.Admin
}
